import { render, staticRenderFns } from "./AddPhoneCall.vue?vue&type=template&id=5441f684&scoped=true&"
import script from "./AddPhoneCall.vue?vue&type=script&lang=js&"
export * from "./AddPhoneCall.vue?vue&type=script&lang=js&"
import style0 from "./AddPhoneCall.vue?vue&type=style&index=0&id=5441f684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5441f684",
  null
  
)

export default component.exports